import { useHasSession, useShowPayments } from "./usePosOrderTableSessionHook";
import usePosSettingsHook from "./usePosSettingsHook";
import { PaymentMethodEnum } from "../utils/enum";
import usePosOrderPayment from "../atoms/usePosOrderPaymentAtom";
import usePaymentHook from "./usePaymentHook";

const usePosPaymentHook = (fromSplitPaymentModal?: boolean) => {
  const hasSession = useHasSession();
  const showPayments = useShowPayments();
  const { settings } = usePosSettingsHook();
  const [paymentId] = usePosOrderPayment();
  const { payments } = usePaymentHook();

  const retList = (settings?.payment_method_options || [])
    .filter((paymentId) =>
      hasSession
        ? paymentId !== PaymentMethodEnum.PAYMENT_METHOD_NOT_KNOWN_YET
        : true
    )
    .filter((payment) =>
      fromSplitPaymentModal ? payment !== PaymentMethodEnum.SPLIT_PAYMENT : true
    )
    .map((paymentId) => payments.find((p) => p.value === paymentId))
    .filter(Boolean);

  const isPaymentUnavailable = retList.every(
    (payment) => payment.value !== paymentId
  );

  return {
    paymentList: retList,
    isPaymentMethodUnavailable: hasSession
      ? showPayments
        ? isPaymentUnavailable
        : false
      : isPaymentUnavailable,
    hasCashPayment: retList.some(
      (payment) => payment.value === PaymentMethodEnum.CASH
    ),
  };
};

export default usePosPaymentHook;
